// extracted by mini-css-extract-plugin
module.exports = {"root":"page-client_root__hL6n_","content":"page-client_content__6xAVP"};